let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iiFuY")).then(() => parcelRequire('hTWUr'));